import { Box, Progress, Text, CircularProgress } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { calculateDateRange } from "../../redux/actions/action";
import QuizDetails from "./QuizDetails";

export default function QuizzesList({ completed, total }) {
    const { quizListData, isLoading } = useSelector(state => state.quizListState)
    const [midTerm, setMidTerm] = useState([])
    const [endTerm, setEndTerm] = useState([])

    const filterQuizzes = () => {
        setMidTerm(quizListData.filter(quiz => quiz.topic_id))
        setEndTerm(quizListData.filter(quiz => !quiz.topic_id))
    }

    useEffect(() => {
        if (quizListData.length) {
            filterQuizzes()
        }
        // eslint-disable-next-line
    }, [quizListData])

    return (
        <Box
            width={['100%', '100%', '100%', '100%', '47.5%']}
            bg='#ffffff'
            height={['250px', '300px', '350px', '350px', '95%']}
            borderRadius='10px'
            // overflowY='auto'
            py='1rem'
            boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
        >
            <Box
                d='flex'
                justifyContent='space-between'
                alignItems='center'
                mb='2'
                px='1.5rem'
            >
                <Text
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    fontSize={['18px', '18px', '22px', '24px', '26px']}
                    fontWeight='900'
                    color='#000000'
                >
                    Quizzes
                </Text>
                <Text
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    fontSize={['8px', '8px', '8px', '12px', '12px']}
                    fontWeight='700'
                    color='#3E59DE'
                    textTransform='uppercase'
                >
                    {completed}/{total} Completed
                </Text>
            </Box>
            <Box
                mb='2'
                px='1.5rem'
            >
                <Progress size='xs' value={(completed / total) * 100} colorScheme='blue' width='100%' borderRadius='md' />
            </Box>
            <Box
                width='100%'
                overflowY='auto'
                d='flex'
                flexDir='column'
                height={['75%', '80%', '80%', '80%', '85%']}
                sx={{
                    '&::-webkit-scrollbar': {
                        width: '10px',
                        borderRadius: '8px',
                        backgroundColor: `transparent`,
                        height: '90%',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: `rgba(255, 255, 255,0.2)`,
                        borderRadius: '20px'
                    },
                }}
            >
                {
                    isLoading ?
                        <Box width='100%' d='flex' justifyContent='center' alignItems='center'>
                            <CircularProgress isIndeterminate color='#3e59de' size='50px' />
                        </Box> :
                        <>
                            {
                                quizListData?.length > 0 &&
                                <Box width='100%' px='1.5rem'>
                                    <Text
                                        style={{ fontFamily: 'Mulish, sans-serif' }}
                                        fontSize={['12px', '12px', '14px', '14px', '16px']}
                                        fontWeight='700'
                                        color='#000000'
                                        textAlign = 'center'
                                    >
                                        MID-TERM
                                    </Text>
                                    {
                                        midTerm.map((quiz, idx) => <QuizDetails
                                            key={idx}
                                            id={quiz.id}
                                            title={quiz.title}
                                            date={quiz.start_date ? calculateDateRange(quiz.start_date, quiz.end_date.split(' ')[0]) : null}
                                            questions={quiz.no_of_questions}
                                            attemptsLeft={quiz["no_of_attempts_left"] ? Number(quiz["no_of_attempts_left"]) : null}
                                            topicId = {quiz.topic_id}
                                        />)
                                    }
                                    <>
                                        {endTerm.length > 0 &&
                                            <>
                                                <Box
                                                    mb='2'
                                                >
                                                    <Progress size='xs' value = '100' colorScheme='blue' width='100%' borderRadius='md' />
                                                </Box>
                                                <Text
                                                    style={{ fontFamily: 'Mulish, sans-serif' }}
                                                    fontSize={['12px', '12px', '14px', '14px', '16px']}
                                                    fontWeight='700'
                                                    color='#000000'
                                                    textAlign = 'center'
                                                >
                                                    END-TERM
                                                </Text>
                                                {
                                                    endTerm.map((quiz, idx) => <QuizDetails
                                                        key={idx}
                                                        id={quiz.id}
                                                        title={quiz.title}
                                                        date={quiz.start_date ? calculateDateRange(quiz.start_date, quiz.end_date.split(' ')[0]) : null}
                                                        questions={quiz.no_of_questions}
                                                        attemptsLeft={quiz["no_of_attempts_left"] ? Number(quiz["no_of_attempts_left"]) : null}
                                                        topicId = {quiz.topic_id}
                                                    />)
                                                }
                                            </>
                                        }
                                    </>
                                </Box>
                            }
                            {
                                quizListData.length === 0 && <Text
                                    tyle={{ fontFamily: 'Mulish, sans-serif' }}
                                    fontSize={['8px', '8px', '8px', '12px', '12px']}
                                    fontWeight='700'
                                    color='#333333'
                                    textTransform='uppercase'
                                    textAlign='center'
                                >
                                    Start some Topic for Quizzes to be available!
                                </Text>
                            }
                        </>
                }
            </Box>
        </Box>
    )
}